import { FileModel } from "@shared/common";

export class AgendaTaskItemModel {
  public constructor(init?: Partial<AgendaTaskItemModel>) {
    Object.assign(this, init);
  }
  Id: number;
  Month: number;
  Day: number;
  Date: string;
  ExecutedDate: string;
  Files: FileModel[];
  AgendaSettingsId: number;
  AgendaCompanyRuleId: number | null;
}
